import type { MechKey } from './keys';

export const ur: Partial<Record<MechKey, string>> = {
  'app.eyebrow': 'میکانیات · 2D',
  'panel.scene': 'منظر',
  'panel.dims': 'پیرامیٹر',
  'panel.style': 'ظاہری شکل',
  'panel.action': 'کنٹرول',
  'style.body': 'جسم',
  'style.vector': 'ویکٹر',
  'style.ground': 'زمین',
  'style.forces': 'قوتیں دکھائیں',
  'style.trace': 'نشان دکھائیں',
  'style.labels': 'ویکٹر لیبل',
  'hint.line1': 'شروع کرنے کے لیے چلائیں پر کلک کریں · اجسام کو کھینچیں',
  'hint.line2': 'سینڈباکس: ایک شکل منتخب کریں، پھر رکھنے کے لیے کلک کریں',
  'scene.incline': 'مائل سطح',
  'scene.projectile': 'پرتابہ حرکت',
  'scene.pendulum': 'لولک',
  'scene.springMass': 'کمانی-کمیت نظام',
  'scene.collisions': 'تصادم',
  'scene.atwood': 'ایٹوڈ مشین',
  'scene.circular': 'دائروی حرکت',
  'scene.sandbox': 'سینڈباکس',
  'dim.angle': 'زاویہ (°)',
  'dim.friction': 'رگڑ',
  'dim.mass': 'کمیت',
  'dim.massA': 'کمیت A',
  'dim.massB': 'کمیت B',
  'dim.velocity': 'رفتار',
  'dim.angleLaunch': 'پرتاب زاویہ (°)',
  'dim.gravity': 'کشش ثقل',
  'dim.gravityX': 'کشش ثقل x',
  'dim.gravityY': 'کشش ثقل y',
  'dim.length': 'لمبائی',
  'dim.damping': 'افتادگی',
  'dim.spring': 'سختی',
  'dim.restitution': 'بحالی',
  'dim.radius': 'نصف قطر',
  'dim.speed': 'چال',
  'action.play': 'چلائیں',
  'action.pause': 'روکیں',
  'action.step': 'قدم',
  'action.reset': 'ری سیٹ',
  'action.speed': 'رفتار',
  'action.clear': 'صاف کریں',
  'force.gravity': 'Fg',
  'force.normal': 'N',
  'force.friction': 'Ff',
  'force.tension': 'T',
  'force.spring': 'Fs',
  'force.applied': 'Fa',
  'force.air': 'Fd',
  'forceName.gravity': 'کشش ثقل',
  'forceName.normal': 'عمودی قوت',
  'forceName.friction': 'رگڑ قوت',
  'forceName.tension': 'تناؤ',
  'forceName.spring': 'کمانی قوت',
  'forceName.applied': 'اطلاقی قوت',
  'forceName.air': 'ہوائی مزاحمت',
  'palette.box': 'صندوق',
  'palette.circle': 'گیند',
  'palette.ramp': 'ڈھلان',
  'palette.ground': 'زمین',
  'palette.hint': 'ایک شکل منتخب کریں، پھر رکھنے کے لیے کینوس پر کلک کریں۔',
  'panel.forces': 'مشاہدہ شدہ قوتیں',
  'forces.empty': 'ابھی کچھ نہیں — منظر چلائیں',
};
